import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-dayjs-3';

Chart.register({ id: 'annotation-plugin-id', ...annotationPlugin });
Chart.register(zoomPlugin);
Chart.register(...registerables);
